import script from "./MyProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProduct.vue?vue&type=script&setup=true&lang=js"

import "./MyProduct.vue?vue&type=style&index=0&id=7cf89a5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf89a5d"]])

export default __exports__